<nz-card [nzActions]="[actionClose, actionDelete]">
    <p> <strong> Sicuro di voler eliminare questo abbonamento?</strong></p>
    <p>Un'email verrà inviata anche al cliente legato a questo abbonamento!</p>
    <p>Questa azione è permanente.</p>
</nz-card>
<ng-template #actionClose>
    <button type="button" nz-button nzSize="large" (click)="onClose()">Annulla</button>
</ng-template>
<ng-template #actionDelete>
    <button nz-button type="button" [nzSize]="'large'" class="home-button" [nzLoading]="loading" (click)="onElimina()">Elimina</button>
</ng-template>